var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardTagsPixels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5372 2.3705C11.1934 2.02666 10.7272 1.83344 10.241 1.83333H3.66667C3.18044 1.83333 2.71412 2.02649 2.3703 2.3703C2.02649 2.71412 1.83333 3.18044 1.83333 3.66667V10.241C1.83344 10.7272 2.02666 11.1934 2.3705 11.5372L10.3492 19.5158C10.7658 19.9298 11.3293 20.1622 11.9167 20.1622C12.504 20.1622 13.0675 19.9298 13.4842 19.5158L19.5158 13.4842C19.9298 13.0675 20.1622 12.504 20.1622 11.9167C20.1622 11.3293 19.9298 10.7658 19.5158 10.3492L11.5372 2.3705Z",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.875 8.15833C7.58377 8.15833 8.15833 7.58377 8.15833 6.875C8.15833 6.16623 7.58377 5.59167 6.875 5.59167C6.16623 5.59167 5.59167 6.16623 5.59167 6.875C5.59167 7.58377 6.16623 8.15833 6.875 8.15833Z",
    fill: "#E60D1E",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTagsPixels);
export default __webpack_public_path__ + "static/media/card-tags-pixels.9f69a79d3311fe8a07397165f427d1f7.svg";
export { ForwardRef as ReactComponent };